__turbopack_context__.v({
  "arrowUp": "sketch-module__g7EUXa__arrowUp",
  "aside": "sketch-module__g7EUXa__aside",
  "bracket": "sketch-module__g7EUXa__bracket",
  "callout": "sketch-module__g7EUXa__callout",
  "calloutArrow": "sketch-module__g7EUXa__calloutArrow",
  "calloutText": "sketch-module__g7EUXa__calloutText",
  "canvas": "sketch-module__g7EUXa__canvas",
  "caption": "sketch-module__g7EUXa__caption",
  "circle": "sketch-module__g7EUXa__circle",
  "circled": "sketch-module__g7EUXa__circled",
  "figure": "sketch-module__g7EUXa__figure",
  "hand": "sketch-module__g7EUXa__hand",
  "hangLg": "sketch-module__g7EUXa__hangLg",
  "hangXl": "sketch-module__g7EUXa__hangXl",
  "ink": "sketch-module__g7EUXa__ink",
  "marginNote": "sketch-module__g7EUXa__marginNote",
  "narrow": "sketch-module__g7EUXa__narrow",
  "noteText": "sketch-module__g7EUXa__noteText",
  "paper": "sketch-module__g7EUXa__paper",
  "strike": "sketch-module__g7EUXa__strike",
  "struck": "sketch-module__g7EUXa__struck",
  "underline": "sketch-module__g7EUXa__underline",
  "underlined": "sketch-module__g7EUXa__underlined",
  "wide": "sketch-module__g7EUXa__wide",
});
